const readIslamicBooks = [
  { label: "Daily", value: "Daily" },
  { label: "Occasionally", value: "Occasionally" },
  { label: "Only During Friday", value: "Only During Friday" },
  { label: "Rarely", value: "Rarely" },
  { label: "Never Read", value: "Never Read" },
];
export default readIslamicBooks;
